<ion-list>
    <ion-item button *ngFor="let item of menu" (click)="click(item)" routerDirection="forward">{{ item.text }}</ion-item>
    <ion-item button detail="false" lines="none" *ngIf="closeText" (click)="close()">{{ closeText }}</ion-item>
</ion-list>